const accordionId = {
  PROFILE_DETAILS_ACCORDION: 'PROFILE_DETAILS_ACCORDION',
  CLIENT_TAG_ACCORDION: 'CLIENT_TAG_ACCORDION',
  CHECK_IN_TEMPLATE_ACCORDION: 'CHECK_IN_TEMPLATE_ACCORDION',
  SUBSCRIPTION_ACCORDION: 'SUBSCRIPTION_ACCORDION',
  PRODUCT_DETAILS_ACCORDION: 'PRODUCT_DETAILS_ACCORDION',
  COMMUNITIES_ACCORDION: 'COMMUNITIES_ACCORDION',
};

export {
  accordionId,
};
